import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { UiModule } from '../../../../components/ui.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { CameraHealthItem } from '../../../../types';

type CellParams = ICellRendererParams<CameraHealthItem>;

@Component({
  selector: 'app-pan-cell-camera-health-camera-status',
  imports: [UiModule, MatTooltipModule, RouterModule],
  templateUrl: './cell-camera-health-camera-status.component.html',
  styleUrl: './cell-camera-health-camera-status.component.scss',
})
export class CellCameraHealthCameraStatusComponent implements ICellRendererAngularComp {
  public params!: CellParams;

  agInit(params: CellParams) {
    this.params = params;
  }

  refresh(params: CellParams) {
    this.params = params;
    return true;
  }
}
